export enum TournamentType {
	SCHEDULED = 1,
	SNG = 2,
	TEST = 3,
}
